// extracted by mini-css-extract-plugin
module.exports = {"bannerAd":"bannerAd___2PXGM","adRendered":"adRendered___3QgYP","adBackground":"adBackground___3QJIf","static":"static___23MfK"};